var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-check-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(35 197)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-35 -197)",
    clipPath: "url(#icon-check-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.067,15.855a.927.927,0,0,1-.659-.275L4.274,11.424a.944.944,0,0,1,0-1.329.929.929,0,0,1,1.32,0l3.475,3.494,8.27-8.315a.928.928,0,0,1,1.32,0,.944.944,0,0,1,0,1.329L9.727,15.58A.927.927,0,0,1,9.067,15.855Z",
    transform: "translate(36 198.574)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.4e51b2d911fd1ac78d4b2492c728ddf4.svg";
export { ForwardRef as ReactComponent };